import { StateConstants } from "../constants/state-constants";
import { ToastrService } from "ngx-toastr";
import { TranslocoService } from "@ngneat/transloco";
import { ResponseForm } from "../models/response-form.model";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class ResponseUtils {
    constructor(private toastrService: ToastrService, private translocoService: TranslocoService) {}

    handleReponse(responseForm: ResponseForm<any>, successMsg: string, errorMsg?: string): void {
        if (this.isSuccess(responseForm)) {
            this.toastrService.success(this.translocoService.translate(successMsg));
            return;
        }

        if (this.isError(responseForm)) {
            const msg = errorMsg
                ? this.translocoService.translate(errorMsg)
                : (responseForm?.errorMessage ?? this.translocoService.translate('common.operationFailed'));
            this.toastrService.error(msg);
        }
    }

    handleResponseCommon(responseForm: ResponseForm<any>) {
        this.handleReponse(responseForm, 'common.operationSuccess', 'common.operationFailed');
    }

    handleReponseOnlySuccess(responseForm: ResponseForm<any>, successMsg: string): void {
        if (this.isSuccess(responseForm)) {
            this.toastrService.success(this.translocoService.translate(successMsg));
        }
    }

    handleReponseOnlyError(responseForm: ResponseForm<any>, errorMsg?: string): void {
        if (this.isError(responseForm)) {
            if (errorMsg) {
                errorMsg = this.translocoService.translate(errorMsg);
            }
            this.toastrService.error(errorMsg ?? responseForm.errorMessage);
        }
    }

    isSuccess(responseForm: ResponseForm<any>): boolean {
        return responseForm?.state === StateConstants.SUCCESS;
        
    }

    isError(responseForm: ResponseForm<any>): boolean {
        return responseForm?.state === StateConstants.ERROR;
    }
}
